export enum ProductionModeEnum  {
  STANDARD = 'standard',
  RUSH = 'rush',
  EXTRA_RUSH = 'extra_rush',
  CUSTOM = 'custom',
}
